import { useSonarProjectSearch } from '../../utils/api-client/api-hooks.ts'
import { SearchPicker } from './search-picker.tsx'

export type SonarProjectSelectorProps = {
  /** The Sonar instance whose projects are offered. The field is disabled until there is one. */
  integrationId: string | undefined
  /** Gets the chosen project's key, or empty once the choice is dropped. */
  onChange: (projectKey: string) => unknown
}

/**
 * Chooses the Sonar project a repository is bound to from the projects its instance actually has.
 *
 * Options are labelled by name with the key beneath. The field doubles as the search box and Sonar
 * matches `search` against names only, so a field showing a key would search for it and find
 * nothing.
 */
export const SonarProjectSelector: React.FC<SonarProjectSelectorProps> = ({ integrationId, onChange }) => (
  <SearchPicker
    key={integrationId}
    label="Sonar project"
    placeholder={integrationId === undefined ? 'Choose an instance first' : 'Search projects by name...'}
    isDisabled={integrationId === undefined}
    noun={{ singular: 'project', plural: 'projects' }}
    emptyMessage="No projects found. Create the project in Sonar first."
    onChange={project => onChange(project?.key ?? '')}
    useSearch={useSonarProjectSearch}
    searchInput={{ integrationId }}
    toOption={project => ({ value: project.key, label: project.name, metadata: project.key })}
  />
)
